const doc = [({"se":({"js":({"components":({"user":({"class_status":({"row":({"view_analysis":"Se analys"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;